import { combineReducers } from 'redux';

import * as actionTypes from '@store/recosting/action-types';

const getAllMyCollections = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_MY_COLLECTIONS_REQUEST:
		case actionTypes.FETCH_MY_COLLECTIONS_FAILURE:
			return state;
		case actionTypes.FETCH_MY_COLLECTIONS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllBrands = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ALL_BRANDS_REQUEST:
		case actionTypes.FETCH_ALL_BRANDS_FAILURE:
			return state;
		case actionTypes.FETCH_ALL_BRANDS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getRequestedBy = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_REQUESTED_BY_REQUEST:
		case actionTypes.FETCH_REQUESTED_BY_FAILURE:
			return state;
		case actionTypes.FETCH_REQUESTED_BY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const initialRecostingState = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getRecosting = (state = initialRecostingState, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_RECOSTING_REQUEST:
		case actionTypes.FETCH_RECOSTING_FAILURE:
			return state;
		case actionTypes.FETCH_RECOSTING_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_MORE_RECOSTING_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
				// totalPages: payload.totalPages
			};
		default:
			return state;
	}
};

const recostingReducer = combineReducers({
	allMyCollections: getAllMyCollections,
	allBrands: getAllBrands,
	requestedBy: getRequestedBy,
	recosting: getRecosting
});

export default recostingReducer;
